import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        backgroundColor: blackTransparent(0.9),
        paddingHorizontal: widthPercentageToDP(16, 240),
    },
    close: {
        position: 'absolute',
        top: 14,
        right: isTabletOrWeb ? 24 : 18,
    },
    flex1: {
        flex: 1,
    },
    tabletContainer: {
        alignItems: 'center',
    },
    text: {
        textAlign: 'center',
    },
    contentContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        position: 'relative',
    },
    phoneButtons: {
        position: 'absolute',
        alignSelf: 'center',
    },
    largeScreenButtons: {
        alignSelf: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 40,
    },
    description: {
        maxWidth: widthPercentageToDP(480),
        marginTop: 16,
        lineHeight: 24,
    },
    mobileErrorCode: {
        marginTop: 8,
    },
    tabletError: {
        position: 'absolute',
        left: widthPercentageToDP(40),
        bottom: heightPercentageToDP(40),
    },
    nonTransparentDialog: {
        backgroundColor: blackTransparent(1),
        marginBottom: androidScreenMarginBottom,
    },
});

export default styles;
